import { type TypedDocumentNode, gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { FirstLineup } from 'components/onboarding/FirstLineup';

import type {
  getCartQuery,
  getCartQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const GET_CART_QUERY = gql`
  query getCartQuery($sport: Sport!, $slug: String!) {
    currentUser {
      slug
      ...FirstLineup_currentUser
    }
    so5 {
      so5Leaderboard(slug: $slug) {
        slug
        id
        ...FirstLineup_so5Leaderboard
      }
    }
  }
  ${FirstLineup.fragments.currentUser}
  ${FirstLineup.fragments.so5Leaderboard}
` as TypedDocumentNode<getCartQuery, getCartQueryVariables>;

const FirstLineupPage = () => {
  const { sport } = useSportContext();
  const { leaderboard } = useTypedParams<PageParams>();

  const { data } = useQuery(GET_CART_QUERY, {
    variables: { sport, slug: leaderboard },
  });

  const { currentUser, so5 } = data || {};
  const { so5Leaderboard } = so5 || {};

  return (
    <FirstLineup currentUser={currentUser} so5Leaderboard={so5Leaderboard} />
  );
};

export default FirstLineupPage;
